import React, { createRef } from "react";
import { BaseInputCSS, Button, CS, Input, RotateLoader } from "@lib/components";
import NumberFormat from "react-number-format";
import styled from "styled-components";
import { inject, observer } from 'mobx-react';
import { MobxComponent } from '../../../../mobx/component';

const NumberInputNoSpinButton = styled(Input)`
  -moz-appearance:textfield;
  ::-webkit-outer-spin-button, ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

interface Props {
	nuvei_data: any;
	amount: number;
	onError: any;
}
interface State {
	loading: boolean;
}

@inject("store") @observer
class NuveiForm extends MobxComponent<Props, State> {
	observer: any
	parentRef: any

	constructor(props: Props) {
		super(props)
		this.state = {
			loading: true
		};
		this.parentRef = createRef();
		this.observer = null;
	}

	onChangeMonthExpiry = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { store } = this.injected;
		const value = e.target.value.replace(/\D/g, "");
		store.checkout.update({ nuvei_month_expiry:value });
	}

	onChangeYearExpiry = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { store } = this.injected;
		const value = e.target.value.replace(/\D/g, "");
		store.checkout.update({ nuvei_year_expiry: value});
	}

	componentDidMount(): void {
		const { store } = this.injected;
		const nuveiPublicKey = store.restaurant.settings.payments.nuvei!.public_key;
		const nuveiPayment = new window.PaymentJs;

		nuveiPayment.init(
			nuveiPublicKey,
			'number_div',
			'cvv_div',
			function(payment: any) {
				payment.setNumberStyle({
					height: '40px',
					// marginBottom: '1rem',
					border: '1px solid #ccc',
					padding: '8px',
					borderRadius: '4px',
					fontSize: 16,
					fontFamily: 'Poppins,Verdana,Helvetica,sans-serif',
					backgroundColor: '#fafafa',
					'::placeholder': {
						'color': '#757575',
					}
				});
				payment.setCvvStyle({
					height: '40px',
					// marginBottom: '1rem',
					border: '1px solid #ccc',
					padding: '8px',
					borderRadius: '4px',
					fontSize: 16,
					fontFamily: 'Poppins,Verdana,Helvetica,sans-serif',
					backgroundColor: '#fafafa',
					width: 100,
					'::placeholder': {
						'color': '#757575',
					}
				});
				payment.setNumberPlaceholder("Card Number");
				payment.setCvvPlaceholder("CVV");
		});
		store.checkout.update({nuveiPayment: nuveiPayment});

		this.observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				// @ts-ignore
				for (const node of mutation.addedNodes) {
					if (node.nodeName === 'IFRAME') {
						this.setState({ loading: false });
						return;
					}
				}
			}
		});
	  
		if (this.parentRef.current) {
			this.observer.observe(this.parentRef.current, {
			  childList: true,
			  subtree: true,
			  attributes: true,
			  characterData: true,
			});
		}
	}

	componentWillUnmount(): void {
		this.injected.store.checkout.update({nuveiPayment: null})
		if (this.observer) {
			this.observer.disconnect();
		  }
	}
	render() {
		const { store } = this.injected;
		const { nuvei_month_expiry, nuvei_year_expiry, nuveiPayment } = store.checkout.s;
		const { loading } = this.state;
		return (
			<div style={{ marginTop: "0.5rem" }}>
				<div id="paymentForm">
					{loading && <RotateLoader size={2} />}
					<div id="number_div" ref={this.parentRef} style={{height: 48}}></div>
					
					<div style={{display: loading ? 'none': 'flex', gap: '2rem', justifyContent: 'space-between'}}>
					
						<div style={{
							display: "flex",
							justifyContent: "space-between",
							gap: ".25rem",
							marginBottom: "1rem",
						}}>
							<Input
								type="text"
								name="card_month_expiry"
								className="col"
								pattern="([0-9]{2})"
								inputMode="numeric"
								placeholder={"MM"}
								onChange={this.onChangeMonthExpiry}
								value={nuvei_month_expiry}
								required={true}
								style={{width: 100, backgroundColor: '#fafafa'}}
							/>
							<Input
								type="text"
								name="card_year_expiry"
								className="col"
								pattern="([0-9]{4})"
								inputMode="numeric"
								placeholder={"YYYY"}
								onChange={this.onChangeYearExpiry}
								value={nuvei_year_expiry}
								required={true}
								style={{width: 100, backgroundColor: '#fafafa'}}
							/>
						</div>

						<div id="cvv_div" style={{height: 48, width: 100}}></div>
					</div>
				</div>

				<p style={{ textAlign: "center", marginTop: "1em", color: "red" }}>
					{this.props.onError}
				</p>
			</div>
		);
	}
}

export default NuveiForm;
